import { createApiCall } from 'lib/base';

const SYNC_STOCK_ACCOUNT_ESIGN_EKYC_API_ID =
  'DASHBOARD/SYNC_STOCK_ACCOUNT_ESIGN_EKYC_API';

const apiCall = createApiCall(
  SYNC_STOCK_ACCOUNT_ESIGN_EKYC_API_ID,
  ({ id }) => ({
    endpoint: `/api/admin/stock-accounts/${id}/esign-ekyc/sync`,
    method: 'POST',
    notify: true,
    isReload: true,
  })
);

export default apiCall;
